import { vslApi } from '@/api';

export default {
  fetchPortList() {
    return vslApi.get('/v1/ports', {
      headers: { common: { delayed: true } },
    });
  },
};
